import React from "react";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import GridNew from "~components/atoms/grid_new/grid_new";
import Image from "~components/atoms/image/image";
import HorizontalDivider from "~components/molecules/horizontal_divider/horizontal_divider";
import { BLOK_ARRAY, RESPONSIVE_VALUE_NEW } from "../../../prop_types";
import * as classes from "./logo_grid.module.scss";

export default function LogoGrid({ logos, logosTitle, gridSplit }) {
  return (
    <div data-testid="logo-grid" className={classes.wrapper}>
      {logosTitle && <HorizontalDivider noMargin text={logosTitle} />}

      <GridNew split={gridSplit}>
        {logos &&
          logos.map((item) => {
            return (
              <SbEditable content={item} key={item._uid}>
                <Image {...item} isCentered width={256} opacity={0.5} />
              </SbEditable>
            );
          })}
      </GridNew>
    </div>
  );
}

LogoGrid.propTypes = {
  logos: BLOK_ARRAY,
  logosTitle: PropTypes.string,
  gridSplit: RESPONSIVE_VALUE_NEW,
};

LogoGrid.defaultProps = {
  logos: null,
  logosTitle: null,
  gridSplit: null,
};
